import React from 'react';
import Card from '../../../../component/Card';
import Form from '../../../../component/Form';
import Table from '../../../../component/Table';

const View = ({
  row,
  penilaianResult,
  values,
  handleChange,
  handleSubmit,
  errors,
  data
}) => {
  console.log(values )
  return (
    <>
      <div className='container-fluid '>
        <div className='row justify-content-center'>
          <div className='col-lg-12'>
            <Card marginTop={ 2 }>
              <Card.Body>
                <h2>Penilaian Pemeriksaan Rumah Makan </h2>
                {/* {penilaianResult.data ? ( */}
                  <>
                    <h3>Hasil Penilaian</h3>
                    <div className='row'>
                      <div className='col-2'>Tingkat Mutu</div>
                      <div className='col'>
                        {penilaianResult.data ? penilaianResult.data.tingkat_mutu : 'belum dinilai'}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>Total Score</div>
                      <div className='col'>
                        {penilaianResult.data ? penilaianResult.data.total_score: 'belum dinilai'}
                      </div>
                    </div>
                  </>
                {/* ) : ( */}
                  <>
                    <Table
                      headers={ [
                        'No',
                        'Variabel',
                        'Komponen Yang Dinilai',
                        'Pagu Nilai',
                        'Nilai Real',
                        'Bobot',
                        'Skor',
                        'Jumlah Skor',
                      ] }
                      data={ row }
                      columnMapper={ (data) => {
                        let totalScore = 0;
                        return [
                          data[ 0 ],
                          data[ 1 ].map((value, i) => (
                            <div key={ i } className='mb-2'>
                              {value.name}
                            </div>
                          )),
                          data[ 1 ].map((value, i) => (
                            <div key={ i } className='mb-2'>
                              {value.keterangan}
                            </div>
                          )),
                          data[ 1 ].map((value, i) => (
                            <div key={ i } className='mb-1'>
                              <input
                                style={ { width: '50px', height: '25px' } }
                                className='form-control form-control-sm'
                                type='number'
                                name={ value.id }
                                // onKeyDown={ (e) => e.preventDefault() }
                                min='0'
                                max={ value.keterangan.split(' ')[ 1 ] }
                                onChange={ (e) =>
                                  handleChange(
                                    e,
                                    value.keterangan.split(' ')[ 1 ]
                                  )
                                }
                              />
                              {errors[ value.id ] && (
                                <span className='text-danger'>
                                  <small>{errors[ value.id ]}</small>
                                </span>
                              )}
                            </div>
                          )),
                          data[ 1 ].map((value, i) => (
                            <div key={ i } className='mb-2'>
                              {value.bobot}
                            </div>
                          )),
                          data[ 1 ].map((value, i) => {
                            const result = values[ value.id ]
                              ? values[ value.id ].value * value.bobot
                              : 0;
                            totalScore += result;
                            return (
                              <div key={ i } className='mb-2'>
                                {result}
                              </div>
                            );
                          }),
                          totalScore,
                        ];
                      } }
                      isBordered
                      pagination={ false }
                    />
                    <div className='row mt-2'>
                      <div className='col d-flex justify-content-end'>
                        <button
                          className='btn btn-success'
                          onClick={ handleSubmit }>
                          Simpan
                        </button>
                      </div>
                    </div>
                  </>
                {/* )} */}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
